import logo from '/images/aikit-plus.svg'
import logoSmall from '/images/aikit-plus-icon.svg'
import { Link } from 'react-router-dom'
import style from './index.module.css'
import cx from 'classnames'

export const Logo = ({ isCollapsed }: { isCollapsed?: boolean }) => {
  return (
    <div className={cx(style.logo, { [style.collapsed]: isCollapsed })}>
      <Link to="/home">
        <img src={isCollapsed ? logoSmall : logo} alt="Logo AI Kit" />
      </Link>
    </div>
  )
}
